import { get, post } from 'services/api';
import { DeleteMessagesRequest } from 'modules/scheduledMessages/types';
import * as utils from 'modules/scheduledMessages/utils';

export const GET_SCHEDULED_MESSAGES_URL = '/i/triggered/scheduledMessages';
export const DELETE_SCHEDULED_MESSAGES_URL = '/triggered/deleteMessages';

/**
 * Fetch the scheduled messages
 */
export const getScheduledMessages = () => get(GET_SCHEDULED_MESSAGES_URL);

/**
 * Delete Messages
 */
export const createDeleteRequest = (deleteAll: boolean) => {
  return function deleteAllScheduledMessages(data: DeleteMessagesRequest) {
    return post(DELETE_SCHEDULED_MESSAGES_URL, {
      deleteAll,
      messageMedium: utils.convertLabelToApiFormat(data.messageMedium), // the API doesn't accept non-letter chars
      ids: data.ids || [],
    });
  };
};

export const deleteAllScheduledMessages = createDeleteRequest(true);
export const deleteScheduledMessagesByID = createDeleteRequest(false);
